'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncButton = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _PrimaryButton2 = require('../PrimaryButton/PrimaryButton');

var _PrimaryButton3 = _interopRequireDefault(_PrimaryButton2);

var _AsyncButton = require('./AsyncButton.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsyncButtonCore = (0, _glamorous2.default)(_PrimaryButton3.default)(_AsyncButton.mapPropsAndThemeToStyle);

/**
 *  Button for asynchoronous actions. Shows a loading icon and prevents click when loading.
 */
var AsyncButton = function AsyncButton(_ref) {
  var loading = _ref.loading,
      className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['loading', 'className', 'children', 'disabled', 'onClick', 'type']);
  return _react2.default.createElement(
    AsyncButtonCore,
    (0, _extends3.default)({
      type: type || 'button',
      className: className,
      disabled: disabled || loading,
      onClick: onClick
    }, rest),
    _react2.default.createElement(
      'div',
      { className: 'buttonFieldRow' },
      children,
      loading && _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse' })
    )
  );
};

exports.AsyncButton = AsyncButton;
AsyncButton.propTypes = {
  /**
   * Child components to display in this button
   */
  children: _propTypes2.default.node,
  /**
   * Classname to pass to the Core Button component
   */
  className: _propTypes2.default.string,
  /**
   * Action to perform on button click.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Action to perform on button click.
   */
  onClick: _propTypes2.default.func,
  /**
   * Whether this buttons asynchorouns action is currently executing.
   * Spins and disables the onClick when true.
   */
  loading: _propTypes2.default.bool,
  /**
   * HTML button type (e.g. 'submit').
   */
  type: _propTypes2.default.string
};

exports.default = AsyncButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/AsyncButton/AsyncButton.js
// module id = 405
// module chunks = 0